import React from 'react'

export const LoadingScreen = () => {
  return (
    <div className="loadingscreen">
      <img  src="../assets/logo.svg" alt="Journal Logo"/>
    </div>
  )
}
